module.exports = __webpack_public_path__ + "static/media/local-screen-share.5b11df5c.svg";